// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"cac2d085","828":"89358f49","842":"8df647c5","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};